<template>
    <div>
		<Modal :open-state="show" @close="() => show = false" id="firstBonus">
			<div>
				<Loader v-if="isLoading" :loading="isLoading" static/>
				<div v-if="!isLoading">
					<a href="" role="button" class="close pos-absolute t-15 r-15" data-dismiss="modal" aria-label="Close">
						<span aria-hidden="true">×</span>
					</a>
					<div id="wizard1" role="application" class="wizard clearfix">
						<div class="steps clearfix align-items-center justify-content-center">
							<ul role="tablist">
								<li role="tab" class="first" :class="[user.is_vk !== false ? 'done' : 'current']" aria-disabled="false" aria-selected="true">
									<a id="wizard1-t-0" href="#wizard1-h-0" aria-controls="wizard1-p-0">
										<span class="current-info audible">current step: </span>
										<span class="number">1</span>
									</a>
								</li>
								<li role="tab" class="" :class="[!user.is_vk ? 'disabled' : 'current']" aria-disabled="true">
									<a id="wizard1-t-1" href="#wizard1-h-1" aria-controls="wizard1-p-1">
										<span class="number">2</span>
									</a>
								</li>
							</ul>
						</div>
						<div class="content clearfix" style="min-height:0!important" v-if="!user.is_vk">
							<h3 id="wizard1-h-0" tabindex="-1" class="title current tx-center">Привяжите аккаунт Вконтакте</h3>
						</div>
						<div class="content clearfix" style="min-height:0!important" v-else>
							<h3 id="wizard1-h-0" tabindex="-1" class="title current tx-center ">Подпишитесь на <a :href="groupLink" target="_blank" style="text-decoration: underline;">нашу группу</a></h3>
							<center class="text-danger" v-if="errors.show">{{ errors.message }}</center>
						</div>
						<div class="actions" v-if="!user.is_vk">
							<a @click="$root.linkVK" class="tx-center" style="cursor: pointer"><i class="ion ion-logo-vk"></i> Привязать</a>
						</div>
						<div class="actions" v-else>
							<a href="#" id="bonBut" @click="getBonus" class="tx-center">Получить</a>
						</div>
					</div>
					<div id="xrqexr" style="font-size:11px;margin-top: 15px;opacity:0.5;cursor:pointer;" @click="hideBonus">Больше не показывать предложение</div>
				</div>
				<!-- modal__body -->
			</div>
		</Modal>
    </div>
</template>

<script>
	import { mapState } from 'pinia'
	import { useUserStore } from '../../stores/User'
	import Modal from "../blocks/Modal.vue";
	import Loader from "../blocks/Loader.vue";

    export default {
		components: {
			Loader,
			Modal
		},
        data() {
            return {
                isLoading: true,
                groupLink: '',
                errors: {
                    show: false,
                    message: ''
                },
				show: false
            }
        },

		mounted() {
			this.getInfoVK();
			this.show = true;
		},

		computed: {
			...mapState(useUserStore, ['user'])
		},

        methods: {
            getInfoVK() {
                this.$root.axios.post('/getGroupVK')
                .then(res => {
                    this.groupLink = res.data;
                    this.isLoading = false;
                })
            },
            hideBonus() {
                this.$root.axios.post('/promo/vk/off')
                .then(res => {
                    const data = res.data;

                    if(data.success) {
                        window.location.reload();
                    } else {
                        this.errors = {
                            show: true,
                            message: data.message
                        };
                    }

                })
            },
            getBonus() {
                this.$root.axios.post('/promo/vk')
                .then(res => {
                    const data = res.data;

                    if(data.success) {
                        this.user.balance += data.sum;
                        this.errors = {
                            show: true,
                            message: ''
                        };
                        setTimeout(() => {
                            window.location.reload();
                        }, 2000);
                    } else {
                        this.errors = {
                            show: true,
                            message: data.message
                        };
                    }

                })
            }
        }
    }
</script>
